import axios from "axios";
import {
    courseLoadingError,
    courseLoadingSuccess,
    coursesIsLoading,
    formSubmitError,
    formSubmitSuccess,
    isSubmittingForm,
    isSubmittingQuestionForm,
    questionFormSubmitError,
    questionFormSubmitSuccess,
    questionsLoadError,
    questionsLoading,
    questionsLoadSuccess,
    quizzesIsLoading,
    quizzesLoadingError,
    quizzesLoadingSuccess,
    resetFormStatus,
    resetQuestionFormStatus,
    topicLoadingError,
    topicLoadingSuccess,
    topicsIsLoading,
    settingsIsLoading,
    settingsLoadingSuccess,
    settingsLoadingError,
    announcementsIsLoading,
    announcementsLoadingSuccess,
    announcementsLoadingError,
    isUpdatingForm,
    formUpdateSuccess,
    formUpdateError,
    courseIntegrityError,
    statisticsIsLoading,
    statisticsLoadingSuccess,
    statisticsLoadingError,
    leadershipBoardIsLoading,
    leadershipBoardLoadingSuccess,
    leadershipBoardLoadingError,
    reportsIsLoading,
    reportsLoadingSuccess,
    reportsLoadingError,
    liveCoursesIsLoading,
    liveCourseLoadingSuccess,
    liveCourseLoadingError,
    selectedCourseIsLoading,
    selectedCourseSuccess,
    selectedCourseError,
    loadComments,
    commentsLoadSuccess,
    commentsLoadError,
    courseLeadershipBoardIsLoading,
    courseLeadershipBoardLoadingSuccess,
    courseLeadershipBoardLoadingError,
    headerProfileLoading,
    headerProfileLoadingSuccess,
    headerProfileLoadingError,
    loadWebexTokens,
    webexTokenLoadSuccess,
    webexTokenLoadError,
} from "../actions/actions";
const url = "https://www.weclassicon.com/elearn/";

//Courses
export const loadCourses = () => {
    return async(dispatch) => {
        const token = JSON.parse(window.localStorage.getItem("user")).access_token
        dispatch(coursesIsLoading());
        try {
            let response = await axios.get(url + "api/courses", { headers: { 'Authorization': 'Bearer ' + token } });
            let courseData = [...response.data.payload.data];
            while (response.data.payload.next_page_url) {
                response = await axios.get(response.data.payload.next_page_url, { headers: { 'Authorization': 'Bearer ' + token } });
                courseData = courseData.concat(response.data.payload.data);
            }
            courseData.sort(
                (a, b) => Date.parse(b.created_at) - Date.parse(a.created_at)
            );
            console.log(courseData)
            dispatch(courseLoadingSuccess(courseData));
        } catch (error) {
            console.log(error.response)
            dispatch(courseLoadingError(error.message));
        }
    };
};

export const submitCourseForm = (formData) => {
    return async(dispatch) => {
        try {
            const token = JSON.parse(window.localStorage.getItem("user")).access_token
            dispatch(isSubmittingForm());
            let response = await axios.post(url + "api/courses", formData, { headers: { 'Authorization': 'Bearer ' + token } });
            if (!response.status === 200) {
                dispatch(
                    formSubmitError(
                        "Server Rejected Data with error code: " + response.status
                    )
                );
            } else {
                dispatch(formSubmitSuccess());
                dispatch(resetFormStatus());
            }
        } catch (error) {
            dispatch(formSubmitError(error.message));
        }
    };
};

export const updateCourseForm = (formData, id) => {
    return async(dispatch) => {
        try {
            const token = JSON.parse(window.localStorage.getItem("user")).access_token
            dispatch(isSubmittingForm());
            let response = await axios.post(url + "api/courses/" + id, formData, { headers: { 'Authorization': 'Bearer ' + token } });
            if (!response.status === 200) {
                dispatch(
                    formSubmitError(
                        "Server Rejected Data with error code: " + response.status
                    )
                );
            } else {
                dispatch(formSubmitSuccess());
                dispatch(resetFormStatus());
            }
        } catch (error) {
            dispatch(formSubmitError(error.message));
        }
    };
};

export const loadEmptyCourses = () => {
    return async(dispatch) => {
        dispatch(coursesIsLoading());
        try {
            setTimeout(() => {
                dispatch(courseLoadingSuccess([]));
            }, 1000);
        } catch (error) {
            dispatch(courseLoadingError(error.message));
        }
    };
};

export const deleteCourse = (courses, id) => {
    return async(dispatch) => {
        const token = JSON.parse(window.localStorage.getItem("user")).access_token
        console.log(token)
        dispatch(coursesIsLoading());
        try {
            let response = await axios.delete(url + "api/courses/" + id, { headers: { 'Authorization': 'Bearer ' + token } });
            if (response.status === 200) {
                dispatch(courseLoadingSuccess(courses));
            } else if (response.status === 202) {
                dispatch(courseIntegrityError())
            } else {
                dispatch(
                    courseLoadingError(
                        "Server threw an error with status: " + response.status
                    )
                );
            }
        } catch (error) {
            dispatch(courseLoadingError(error.message));
        }
    };
};

//Topics
export const loadEmptyTopics = () => {
    return async(dispatch) => {
        dispatch(topicsIsLoading());
        try {
            setTimeout(() => {
                dispatch(topicLoadingSuccess([]));
            }, 1000);
        } catch (error) {
            dispatch(topicLoadingError(error.message));
        }
    };
};

export const deleteTopic = (topics, id) => {
    return async(dispatch) => {
        const token = JSON.parse(window.localStorage.getItem("user")).access_token
        dispatch(topicsIsLoading());
        try {
            let response = await axios.delete(url + "api/topics/" + id, { headers: { 'Authorization': 'Bearer ' + token } });
            if (response.status !== 200) {
                dispatch(
                    topicLoadingError(
                        "Server threw an error with status: " + response.status
                    )
                );
            } else {
                dispatch(topicLoadingSuccess(topics));
            }
        } catch (error) {
            dispatch(topicLoadingError(error.message));
        }
    };
};

export const loadTopics = () => {
    return async(dispatch) => {
        dispatch(topicsIsLoading());
        const token = JSON.parse(window.localStorage.getItem("user")).access_token
        try {
            let response = await axios.get(url + "api/topics", { headers: { 'Authorization': 'Bearer ' + token } });
            let topicsData = [...response.data.payload.data];
            while (response.data.payload.next_page_url) {
                response = await axios.get(response.data.payload.next_page_url, { headers: { 'Authorization': 'Bearer ' + token } });
                topicsData = topicsData.concat(response.data.payload.data);
            }
            // topicsData.sort(
            //     (a, b) => Date.parse(a.created_at) - Date.parse(b.created_at)
            // );
            dispatch(topicLoadingSuccess(topicsData));
        } catch (error) {
            console.log(error.response)
            dispatch(topicLoadingError(error.message));
        }
    };
};

export const submitTopicForm = (formData) => {
    return async(dispatch) => {
        const token = JSON.parse(window.localStorage.getItem("user")).access_token
        try {
            dispatch(isSubmittingForm());
            let response = await axios.post(url + "api/topics", formData, { headers: { 'Authorization': 'Bearer ' + token } });
            // console.log(response)
            if (!response.status === 200) {
                dispatch(
                    formSubmitError(
                        "Server Rejected Data! with error code: " + response.status
                    )
                );
            } else {
                dispatch(formSubmitSuccess());
                dispatch(resetFormStatus());
            }
        } catch (error) {
            // console.log(error.message)
            dispatch(formSubmitError(error.message));
        }
    };
};
export const updateTopicForm = (formData, id) => {
    return async(dispatch) => {
        const token = JSON.parse(window.localStorage.getItem("user")).access_token
        try {
            dispatch(isSubmittingForm());
            let response = await axios.put(url + "api/topics/" + id, formData, { headers: { 'Authorization': 'Bearer ' + token } });
            // console.log(response)
            if (!response.status === 200) {
                dispatch(
                    formSubmitError(
                        "Server Rejected Data! with error code: " + response.status
                    )
                );
            } else {
                dispatch(formSubmitSuccess());
                dispatch(resetFormStatus());
            }
        } catch (error) {
            // console.log(error.message)
            dispatch(formSubmitError(error.response.data.message));
        }
    };
};
export const loadSettings = (formData) => {
    return async(dispatch) => {
        dispatch(settingsIsLoading());
        const token = JSON.parse(window.localStorage.getItem("user")).access_token
        try {
            let response = await axios.get(url + "api/settings", {
                headers: { 'Authorization': 'Bearer ' + token },
                params: {
                    email: formData.email,
                    token: token,
                },
            });
            let settingsData = {...response.data.payload };
            dispatch(settingsLoadingSuccess(settingsData));
        } catch (error) {
            dispatch(settingsLoadingError(error.message));
        }
    };
};

export const updateProfile = (formData) => {
    return async(dispatch) => {
        dispatch(isUpdatingForm());
        const token = JSON.parse(window.localStorage.getItem("user")).access_token
        try {
            let response = await axios.post(url + "api/updateProfile", formData, { headers: { 'Authorization': 'Bearer ' + token } });
            if (!response.status === 200) {
                dispatch(
                    formUpdateError(
                        "Server Rejected Data! with error code: " + response.status
                    )
                );
            }
            dispatch(formUpdateSuccess());
            dispatch(resetFormStatus());
        } catch (error) {
            dispatch(formUpdateError(error.message));
        }
    };
};

export const submitChangePassword = (formData) => {
    return async(dispatch) => {
        dispatch(isSubmittingForm());
        const token = JSON.parse(window.localStorage.getItem("user")).access_token
        try {
            let response = await axios.post(url + "api/changePassword", formData, { headers: { 'Authorization': 'Bearer ' + token } });
            if (!response.status === 200) {
                dispatch(
                    formSubmitError(
                        "Server Rejected Data! with error code: " + response.status
                    )
                );
            }
            dispatch(formSubmitSuccess());
            dispatch(resetFormStatus());
        } catch (error) {
            dispatch(formSubmitError(error.message));
        }
    };
};

//Quizzes

export const loadEmptyQuizzes = () => {
    return async(dispatch) => {
        dispatch(quizzesIsLoading());
        try {
            setTimeout(() => {
                dispatch(quizzesLoadingSuccess([]));
            }, 1000);
        } catch (error) {
            dispatch(quizzesLoadingError(error.message));
        }
    };
};

export const loadQuizzes = () => {
    return async(dispatch) => {
        const token = JSON.parse(window.localStorage.getItem("user")).access_token
        dispatch(quizzesIsLoading());
        try {
            let response = await axios.get(url + "api/quiz", { headers: { 'Authorization': 'Bearer ' + token } });
            let quizzesData = [...response.data.payload.data];
            while (response.data.payload.next_page_url) {
                response = await axios.get(response.data.payload.next_page_url, { headers: { 'Authorization': 'Bearer ' + token } });
                quizzesData = quizzesData.concat(response.data.payload.data);
            }
            quizzesData.sort(
                (a, b) => Date.parse(b.created_at) - Date.parse(a.created_at)
            );
            console.log(quizzesData)
            dispatch(quizzesLoadingSuccess(quizzesData));
        } catch (error) {
            dispatch(quizzesLoadingError(error.message));
        }
    };
};

export const deleteQuiz = (quizzes, id) => {
    return async(dispatch) => {
        const token = JSON.parse(window.localStorage.getItem("user")).access_token
        dispatch(quizzesIsLoading());
        try {
            let response = await axios.delete(url + "api/quiz/" + id, { headers: { 'Authorization': 'Bearer ' + token } });
            if (response.status !== 200) {
                dispatch(
                    quizzesLoadingError(
                        "Server threw an error with status: " + response.status
                    )
                );
            } else {
                dispatch(quizzesLoadingSuccess(quizzes));
            }
        } catch (error) {
            dispatch(quizzesLoadingError(error.message));
        }
    };
};

export const submitQuizForm = (formData) => {
    return async(dispatch) => {
        const token = JSON.parse(window.localStorage.getItem("user")).access_token
        try {
            dispatch(isSubmittingForm());
            let response = await axios.post(url + "api/quiz", formData, { headers: { 'Authorization': 'Bearer ' + token } });
            // console.log(response)
            if (!response.status === 200) {
                console.log(response)
                dispatch(formSubmitError(response.data.message));
            } else {
                // console.log("before local storage");
                localStorage.setItem("quizId", response.data.payload.id);
                dispatch(formSubmitSuccess());
                dispatch(resetFormStatus());
            }
        } catch (error) {
            console.log(error.response.data.message)
            dispatch(formSubmitError(error.response.data ? error.response.data.message : "Error!"));
        }
    };
};

export const updateQuizForm = (formData, id) => {
    return async(dispatch) => {
        const token = JSON.parse(window.localStorage.getItem("user")).access_token
        try {
            dispatch(isSubmittingForm());
            let response = await axios.put(url + "api/quiz/" + id, formData, { headers: { 'Authorization': 'Bearer ' + token } });
            // console.log(response)
            if (!response.status === 200) {
                dispatch(
                    formSubmitError(
                        "Server Rejected Data! with error code: " + response.status
                    )
                );
            } else {
                dispatch(formSubmitSuccess());
                dispatch(resetFormStatus());
            }
        } catch (error) {
            // console.log(error.message);
            dispatch(formSubmitError(error.message));
        }
    };
};

export const loadTopicsForSelectedCourse = (courseId) => {
    return async(dispatch) => {
        const token = JSON.parse(window.localStorage.getItem("user")).access_token
        dispatch(topicsIsLoading());
        try {
            let response = await axios.get(url + "api/course_topics/" + courseId, { headers: { 'Authorization': 'Bearer ' + token } });
            // console.log(response.data.payload);
            let topicsData = [...response.data.payload];
            while (response.data.payload.next_page_url) {
                response = await axios.get(response.data.payload.next_page_url, { headers: { 'Authorization': 'Bearer ' + token } });
                topicsData = topicsData.concat(response.data.payload);
            }
            // console.log(data)
            topicsData = topicsData.filter(topic => topic.status === 'Y' && topic.quiz_status.toUpperCase() === 'Y')
            topicsData.sort(
                (a, b) => Date.parse(b.created_at) - Date.parse(a.created_at)
            );
            dispatch(topicLoadingSuccess(topicsData));
        } catch (error) {
            dispatch(topicLoadingError(error.message));
        }
    };
};


//the loadEmptyTopics above is for simulating an empty topics page, and the 1 second delay is mimcking an API call.
//I had to duplicate that same function here, and remove the setTimeout so that the reset to empty topics is instant for quiz module.
//we can remove the load empty topics above in production
export const loadEmptyTopicsInstantly = () => {
    return async(dispatch) => {
        dispatch(topicsIsLoading());
        try {
            dispatch(topicLoadingSuccess([]));
        } catch (error) {
            dispatch(topicLoadingError(error.message));
        }
    };
};

//Questions and Choices

export const submitQuestionAndChoices = (formData) => {
    return async(dispatch) => {
        const token = JSON.parse(window.localStorage.getItem("user")).access_token
        try {
            dispatch(isSubmittingQuestionForm());
            let response = await axios.post(url + "api/quiz_questions", formData, { headers: { 'Authorization': 'Bearer ' + token } });
            // console.log(response)
            if (!response.status === 200) {
                dispatch(
                    formSubmitError(
                        "Server Rejected Data! with error code: " + response.status
                    )
                );
            } else {
                dispatch(questionFormSubmitSuccess());
                dispatch(resetQuestionFormStatus());
            }
        } catch (error) {
            console.log(error.response.data.message)
            dispatch(questionFormSubmitError(error.response.data.message));
        }
    };
};

export const loadQuizQuestions = (id) => {
    return async(dispatch) => {
        const token = JSON.parse(window.localStorage.getItem("user")).access_token
        try {
            dispatch(questionsLoading());
            let response = await axios.get(url + `api/quiz/quiz_questions/${id}`, { headers: { 'Authorization': 'Bearer ' + token } });
            let questions = response.data.payload;
            let displayQuestions = questions.map((question) => {
                return {
                    question: {
                        ...question,
                        question_title: question.question,
                        status: question.status,
                    },
                    choices: question.quiz_choices,
                };
            });
            dispatch(questionsLoadSuccess(displayQuestions));
        } catch (error) {
            dispatch(questionsLoadError(error.message));
        }
    };
};

export const deleteQuestion = (questions, id) => {
    return async(dispatch) => {
        const token = JSON.parse(window.localStorage.getItem("user")).access_token
        dispatch(questionsLoading());
        try {
            let response = await axios.delete(url + "api/quiz_questions/" + id, { headers: { 'Authorization': 'Bearer ' + token } });
            if (response.status !== 200) {
                dispatch(
                    questionsLoadError(
                        "Server threw an error with status: " + response.status
                    )
                );
            } else {
                dispatch(questionsLoadSuccess(questions));
            }
        } catch (error) {
            dispatch(questionsLoadError(error.message));
        }
    };
};

//non-redux api calls
export const deleteChoice = async(choices) => {
    const token = JSON.parse(window.localStorage.getItem("user")).access_token
    try {
        for (let choice of choices) {
            await axios.delete(url + `/api/choice/${choice.id}`, { headers: { 'Authorization': 'Bearer ' + token } });
        }
    } catch (error) {
        throw error;
    }
};

export const addChoice = async(choices, question_id) => {
    const token = JSON.parse(window.localStorage.getItem("user")).access_token
    try {
        for (let choice of choices) {
            let formData = {...choice, question_id: question_id }
            await axios.post(url + "api/choice", formData, { headers: { 'Authorization': 'Bearer ' + token } });
        }
    } catch (error) {
        throw error;
    }
}

export const updateChoice = async(choices) => {
    const token = JSON.parse(window.localStorage.getItem("user")).access_token
    try {
        for (let i = 0; i < choices.length; i++) {
            let formData = {
                question_id: choices[i].question_id,
                choice: choices[i].choice,
                is_right_choice: choices[i].is_right_choice,
                status: choices[i].status,
            };
            await axios.put(
                url + `api/choice/${choices[i].id}`,
                formData, { headers: { 'Authorization': 'Bearer ' + token } }
            );
            // console.log(
            //     response.status +
            //     " for choice no. " +
            //     choices[i].id +
            //     " which is " +
            //     choices[i].choice
            // );
        }
    } catch (error) {
        throw error;
    }
    /*
      "question_id":1,
      "choice": "update choice 1",
      "is_right_choice": "Y",
      "status": "Y"
      */
};

export const updateQuestion = async(id, formData) => {
    let data = {};
    data["question"] = formData.question_title;
    data["no_of_choices"] = formData.no_of_choices;
    data["quiz_id"] = formData.quiz_id;
    data["status"] = formData.status;
    const token = JSON.parse(window.localStorage.getItem("user")).access_token
    try {
        let response = await axios.put(url + `api/quiz_questions/${id}`, data, { headers: { 'Authorization': 'Bearer ' + token } });
        return response.data.payload;
    } catch (error) {
        throw error;
    }
};

export const addOneQuestionAndChoices = async(formData) => {
    const token = JSON.parse(window.localStorage.getItem("user")).access_token
    try {
        await axios.post(url + "api/quiz_questions", formData, { headers: { 'Authorization': 'Bearer ' + token } });
    } catch (error) {
        throw error;
    }
};

export const loadAnnouncements = () => {
    return async(dispatch) => {
        const token = JSON.parse(window.localStorage.getItem("user")).access_token
        dispatch(announcementsIsLoading());
        try {
            let response = await axios.get(url + "api/announcements", { headers: { 'Authorization': 'Bearer ' + token } });
            let announcementsData = [...response.data.payload.data];
            while (response.data.payload.next_page_url) {
                response = await axios.get(response.data.payload.next_page_url, { headers: { 'Authorization': 'Bearer ' + token } });
                announcementsData = announcementsData.concat(
                    response.data.payload.data
                );
            }
            announcementsData.sort(
                (a, b) => Date.parse(b.created_at) - Date.parse(a.created_at)
            );
            dispatch(announcementsLoadingSuccess(announcementsData));
        } catch (error) {
            dispatch(announcementsLoadingError(error.message));
        }
    };
};

export const submitAnnouncementForm = (formData) => {
    return async(dispatch) => {
        try {
            const token = JSON.parse(window.localStorage.getItem("user")).access_token
            dispatch(isSubmittingForm());
            let response = await axios.post(url + "api/announcements", formData, { headers: { 'Authorization': 'Bearer ' + token } });
            if (!response.status === 200) {
                dispatch(
                    formSubmitError(
                        "Server Rejected Data with error code: " + response.status
                    )
                );
            } else {
                dispatch(formSubmitSuccess());
                dispatch(resetFormStatus());
            }
        } catch (error) {
            dispatch(formSubmitError(error.message));
        }
    };
};

export const updateAnnouncementForm = (formData, id) => {
    return async(dispatch) => {
        try {
            const token = JSON.parse(window.localStorage.getItem("user")).access_token
            dispatch(isSubmittingForm());
            let response = await axios.post(url + "api/announcements/" + id, formData, { headers: { 'Authorization': 'Bearer ' + token } });
            if (!response.status === 200) {
                dispatch(
                    formSubmitError(
                        "Server Rejected Data with error code: " + response.status
                    )
                );
            } else {
                dispatch(formSubmitSuccess());
                dispatch(resetFormStatus());
            }
        } catch (error) {
            dispatch(formSubmitError(error.message));
        }
    };
};

export const deleteAnnouncement = (announcements, id) => {
    return async(dispatch) => {
        const token = JSON.parse(window.localStorage.getItem("user")).access_token
        dispatch(announcementsIsLoading());
        try {
            let response = await axios.delete(url + "api/announcements/" + id, { headers: { 'Authorization': 'Bearer ' + token } });
            if (response.status !== 200) {
                dispatch(
                    courseLoadingError(
                        "Server threw an error with status: " + response.status
                    )
                );
            } else {
                dispatch(announcementsLoadingSuccess(announcements));
            }
        } catch (error) {
            dispatch(announcementsLoadingError(error.message));
        }
    };
};

export const loadStatistics = (type, id) => {
    return async(dispatch) => {
        dispatch(statisticsIsLoading());
        const token = JSON.parse(window.localStorage.getItem("user")).access_token
        let route = type === 'main' ? "api/dashboard" : "api/course_dashboard/" + id
        try {
            let response = await axios.get(url + route, { headers: { 'Authorization': 'Bearer ' + token } });
            let statisticsData = 'end_term_quizz' in response.data.payload ? [response.data.payload] : [...response.data.payload];
            dispatch(statisticsLoadingSuccess(statisticsData));
        } catch (error) {
            dispatch(statisticsLoadingError(error));
        }
    };
};

export const loadLeadershipBoard = () => {
    const token = JSON.parse(window.localStorage.getItem("user")).access_token
    return async(dispatch) => {
        dispatch(leadershipBoardIsLoading());
        try {
            let response = await axios.get(url + "api/leadership_dashboard", { headers: { 'Authorization': 'Bearer ' + token } });
            // console.log(response.data)
            let leadershipBoardData = [...response.data.payload.data];
            leadershipBoardData.sort((a, b) => b.scores_count - a.scores_count)
            // console.log(leadershipBoardData)
            dispatch(leadershipBoardLoadingSuccess(leadershipBoardData));
        } catch (error) {
            dispatch(leadershipBoardLoadingError(error.message));
        }
    };
};

export const loadCourseLeadershipBoard = (id) => {
    const token = JSON.parse(window.localStorage.getItem("user")).access_token
    return async(dispatch) => {
        dispatch(courseLeadershipBoardIsLoading());
        try {
            let response = await axios.get(url + "api/course_leadership_board/" + id, { headers: { 'Authorization': 'Bearer ' + token } });
            let leadershipBoardData = [...response.data.payload.data];
            leadershipBoardData.sort((a, b) => b.scores_count - a.scores_count)
            dispatch(courseLeadershipBoardLoadingSuccess(leadershipBoardData));
        } catch (error) {
            dispatch(courseLeadershipBoardLoadingError(error.message));
        }
    };
};

export const loadReports = () => {
    return async(dispatch) => {
        const token = JSON.parse(window.localStorage.getItem("user")).access_token
        dispatch(reportsIsLoading());
        try {
            let response = await axios.get(url + "api/reports", { headers: { 'Authorization': 'Bearer ' + token } });
            let reportsData = {...response.data.payload };
            dispatch(reportsLoadingSuccess(reportsData));
        } catch (error) {
            dispatch(reportsLoadingError(error.message));
        }
    };
};

export const submitLiveCourseForm = (meetingData, tokens, courseImage, keywords) => {
    return async(dispatch) => {
        try {
            dispatch(isSubmittingForm());
            console.log(tokens.access_token)
            let response = await axios.post('https://webexapis.com/v1/meetings', meetingData, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${tokens.access_token}`
                    }
                })
                // console.log(response.data)
            let createdMeeting = response.data
            storeMeeting(createdMeeting, dispatch, courseImage, keywords)
        } catch (error) {
            console.log(error.response.data.message)
            let response = await fetch("https://webexapis.com/v1/access_token?client_id=Cab35d58ec1973764ce127fbb5b3d8f28475061cc367af8b6987acb2efd206dc0&grant_type=refresh_token&redirect_uri=http%3A%2F%2Flocalhost%3A3000%2Fadd-live-courses&scope=spark%3Aall%20spark%3Akms&client_secret=d446138322c8a32b5d074573dd8ea3c0d7bea6fbae6f9a44fa1be6c57a207dad&refresh_token=" + tokens.refresh_token, { method: 'POST', headers: { 'content-type': 'application/x-www-form-urlencoded' } })
            if (response.status === 400) {
                dispatch(formSubmitError(error.response.data.message));
            } else {
                let data = await response.json()
                dispatch(submitLiveCourseForm(meetingData, data, courseImage, keywords))
            }
        }
    };
};

async function storeMeeting(createdMeeting, dispatch, courseImage, keywords) {
    const token = JSON.parse(window.localStorage.getItem("user")).access_token
    let formData = new FormData()

    formData.append("meeting_id", createdMeeting.id)
    formData.append("meeting_number", createdMeeting.meetingNumber)
    formData.append("title", createdMeeting.title)
    formData.append("agenda", createdMeeting.agenda)
    formData.append("start", createdMeeting.start)
    formData.append("end", createdMeeting.end)
    formData.append("host_user_id", createdMeeting.hostUserId)
    formData.append("host_email", createdMeeting.hostEmail)
    formData.append("host_name", createdMeeting.hostDisplayName)
    formData.append("host_key", createdMeeting.hostKey)
    formData.append("web_link", createdMeeting.webLink)
    formData.append("cover_image", courseImage)
    formData.append("keywords", keywords)

    let response = await axios.post(url + "api/meetings", formData, { headers: { 'Authorization': 'Bearer ' + token } });
    if (!response.status === 200) {
        dispatch(
            formSubmitError(
                "Server Rejected Data with error code: " + response.status
            )
        );
    } else {
        dispatch(formSubmitSuccess());
        dispatch(resetFormStatus());
    }
}

export const loadLiveCourses = () => {
    return async(dispatch) => {
        dispatch(liveCoursesIsLoading());
        const token = JSON.parse(window.localStorage.getItem("user")).access_token
        try {
            let response = await axios.get(url + "api/meetings", { headers: { 'Authorization': 'Bearer ' + token } });
            let liveCourseData = [...response.data.payload.data];
            while (response.data.payload.next_page_url) {
                response = await axios.get(response.data.payload.next_page_url, { headers: { 'Authorization': 'Bearer ' + token } });
                liveCourseData = liveCourseData.concat(response.data.payload.data);
            }
            liveCourseData.sort(
                (a, b) => Date.parse(b.created_at) - Date.parse(a.created_at)
            );
            dispatch(liveCourseLoadingSuccess(liveCourseData));
        } catch (error) {
            dispatch(liveCourseLoadingError(error.message));
        }
    };
};

export const loadSelectedCourse = (id) => {
    return async(dispatch) => {
        const token = JSON.parse(window.localStorage.getItem("user")).access_token
        dispatch(selectedCourseIsLoading())
        try {
            let response = await axios.get(url + 'api/courses/' + id, { headers: { 'Authorization': 'Bearer ' + token } })
            let course = response.data.payload
            console.log(course, "selected course")
            response = await axios.get(url + 'api/course_topics/' + id, { headers: { 'Authorization': 'Bearer ' + token } })
            course["topics"] = response.data.payload
            dispatch(selectedCourseSuccess(course))
        } catch (error) {
            dispatch(selectedCourseError(error.message))
        }
    }
}

export const loadCourseComments = (id) => {
    return async(dispatch) => {
        const token = JSON.parse(window.localStorage.getItem("user")).access_token
        dispatch(loadComments());
        try {
            let response = await axios.get(url + "api/course_comments/" + id, { headers: { 'Authorization': 'Bearer ' + token } });
            let commentsData = [...response.data.payload.data];
            while (response.data.payload.next_page_url) {
                response = await axios.get(response.data.payload.next_page_url, { headers: { 'Authorization': 'Bearer ' + token } });
                commentsData = commentsData.concat(response.data.payload.data);
            }
            console.log(commentsData)
            commentsData.sort(
                (a, b) => Date.parse(b.created_at) - Date.parse(a.created_at)
            );
            dispatch(commentsLoadSuccess(commentsData));
        } catch (error) {
            dispatch(commentsLoadError(error.response.data.message));
        }
    };
};


export const updateListOfTopicsForSelectedCourse = (payload) => {
    return async(dispatch) => {
        const token = JSON.parse(window.localStorage.getItem("user")).access_token
        dispatch(selectedCourseIsLoading())
        const formData = {...payload};
        try {
            await axios.post(url + 'api/topics_order', formData, { headers: { 'Authorization': 'Bearer ' + token } })
        } catch (error) {
            dispatch(selectedCourseError(error.message))
        }
    }
}

export const loginUser = async(loginDetails) => {
    try {
        let response = await axios.post(url + 'api/trainer/login', loginDetails)
        console.log(response.data.payload)
        return response.data.payload
    } catch (error) {
        throw error
    }
}

export const logout = async() => {
    const token = JSON.parse(window.localStorage.getItem("user")).access_token
    try {
        await axios.post(url + 'api/trainer/logout', { headers: { 'Authorization': 'Bearer ' + token } })
        return true
    } catch (error) {
        throw error
    }
}

export const loadHeaderProfile = () => {
    const token = JSON.parse(window.localStorage.getItem("user")).access_token
    return async(dispatch) => {
        dispatch(headerProfileLoading());
        try {
            let response = await axios.get(url + "api/notifications", { headers: { 'Authorization': 'Bearer ' + token } });
            let notificationData = [...response.data.payload.data];
            while (response.data.payload.next_page_url) {
                response = await axios.get(response.data.payload.next_page_url, { headers: { 'Authorization': 'Bearer ' + token } });
                notificationData = notificationData.concat(response.data.payload.data);
            }
            notificationData.sort((a, b) => Date.parse(b.date) - Date.parse(a.date))
            dispatch(headerProfileLoadingSuccess(notificationData));
        } catch (error) {
            dispatch(headerProfileLoadingError(error.message));
        }
    };
};

export const getWebexTokens = (userId) => {
    return async(dispatch) => {
        const token = JSON.parse(window.localStorage.getItem("user")).access_token
        dispatch(loadWebexTokens());
        try {
            let response = await axios.get(url + "api/webex_token/" + userId, { headers: { 'Authorization': 'Bearer ' + token } });
            let tokens = response.data.payload;
            console.log(tokens, "tokens")
            dispatch(webexTokenLoadSuccess(tokens));
        } catch (error) {
            dispatch(webexTokenLoadError(error.message));
        }
    };
}

export const setWebexTokens = (userId, tokens) => {
    //tokens is webex tokens
    return async(dispatch) => {
        const token = JSON.parse(window.localStorage.getItem("user")).access_token
        dispatch(loadWebexTokens());
        try {
            let body = {
                user_id: userId,
                access_token: tokens.access_token,
                refresh_token: tokens.refresh_token
            }
            await axios.post(url + "api/webex_token", body, { headers: { 'Authorization': 'Bearer ' + token } });
            console.log(tokens, "tokens")
            dispatch(webexTokenLoadSuccess(tokens));
        } catch (error) {
            dispatch(webexTokenLoadError(error.message));
        }
    };
}